// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zYZx","content":"styles_content__2kqLk","row":"styles_row__28SeB","footer":"styles_footer__ByOUp","phraseLength":"styles_phraseLength__-mqgp"};